/**
 * @see /client/components/ListFilters/index.js
 * @see /client/containers/OrderSummary/index.js
 * @see /client/containers/ZingerMeal/index.js
 * @see /client/containers/PlanAParty/index.js
 * @todo: need to make the similar with @see /client/components/Radio/index.js
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import CheckboxInput from './CheckboxInput';

class Checkbox extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: props.isChecked || false,
    };
  }

  render() {
    const { isChecked } = this.state;
    const { id, children, onChange, payloadKey, disabled, name = null, autoFocus } = this.props;
    return (
      <CheckboxInput>
        <input
          id={id}
          disabled={disabled && !this.state.isChecked}
          checked={isChecked}
          type="checkbox"
          onChange={() => {
            const checked = !this.state.isChecked;
            this.setState({ isChecked: checked });
            onChange(payloadKey, id, checked, name);
          }}
          autoFocus={autoFocus}
        />
        <label htmlFor={id}>
          {children}
        </label>
      </CheckboxInput>
    );
  }
}

Checkbox.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
  payloadKey: PropTypes.string,
  name: PropTypes.string,
  autoFocus: PropTypes.bool,
};

Checkbox.defaultProps = {
  isChecked: false,
  payloadKey: 'Checkbox',
  onChange: () => '',
  autoFocus: false,
};
export default Checkbox;



// WEBPACK FOOTER //
// client/components/Checkbox/index.js